/**
 * Exit Intent Detection for Newsletter Popup
 * Detects when user is about to leave and triggers popup
 */

(function() {
  'use strict';

  let exitIntentTriggered = false;
  const exitIntentThreshold = 10; // pixels from top to trigger

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  function hasSeenPopup(sectionId) {
    return getCookie(`newsletter-${sectionId}`) === 'opened' ||
           localStorage.getItem(`newsletter-${sectionId}`) === 'opened';
  }

  function detectExitIntent(e, sectionId, enableExitIntent) {
    // Only trigger if exit intent is enabled and not already triggered
    if (!enableExitIntent || exitIntentTriggered || hasSeenPopup(sectionId)) {
      return;
    }

    // Check if mouse is leaving from the top of the viewport
    const shouldTrigger =
      e.clientY <= exitIntentThreshold &&
      e.relatedTarget === null &&
      e.toElement === null;

    if (shouldTrigger) {
      exitIntentTriggered = true;

      // Trigger the popup
      const popup = document.querySelector(`#NewsletterPopup-${sectionId}`);
      if (popup && window.theme && window.theme.NewsletterPopup) {
        // Manually open the modal
        const event = new CustomEvent('modalOpen', {
          detail: { id: `NewsletterPopup-${sectionId}` }
        });
        document.dispatchEvent(event);
      }

      // Remove listener after triggering
      document.removeEventListener('mouseout', exitIntentHandler);
    }
  }

  function exitIntentHandler(e) {
    const popup = document.querySelector('[data-section-type="newsletter-popup"]');
    if (!popup) return;

    const sectionId = popup.dataset.sectionId;
    const enableExitIntent = popup.dataset.enableExitIntent === 'true';

    detectExitIntent(e, sectionId, enableExitIntent);
  }

  // Only activate on desktop (mobile exit intent is unreliable)
  if (window.innerWidth > 768) {
    document.addEventListener('mouseout', exitIntentHandler);
  }

})();
